import { FeatureConfig } from '@/domains/feature-config/types/feature-config.interface';
import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
export const useFeatureConfig = createSharedComposable(() => {
    const featureConfig = injectService(FeatureConfig);
    const region = featureConfig.region;
    const isCN = featureConfig.isCN;
    const isEU = featureConfig.isEU;
    const isUS = featureConfig.isUS;
    const helpCenterLinkAboutAiTagging = featureConfig.helpCenterLinkAboutAiTagging;
    const helpCenterLinkAboutCustomField = featureConfig.helpCenterLinkAboutCustomField;
    const helpCenterLinkAboutEmptyData = featureConfig.helpCenterLinkAboutEmptyData;
    const helpCenterLinkAboutSpaceTransfer = featureConfig.helpCenterLinkAboutSpaceTransfer;
    const helpCenterLinkAboutCompanySpace = featureConfig.helpCenterLinkAboutCompanySpace;
    const helpCenterLinkAboutSpaceShare = featureConfig.helpCenterLinkAboutSpaceShare;
    const isImageTextShowAllFamily = featureConfig.isImageTextShowAllFamily;
    const isShowJpTranslation = featureConfig.isShowJpTranslation;
    const enableStandardCompanyProfile = featureConfig.enableStandardCompanyProfile;
    const requestDemoLinkTemplate = featureConfig.requestDemoLinkTemplate;
    const synapseHiddenKey = featureConfig.synapseHiddenKey;
    const defaultViewTypeByRegion = featureConfig.defaultViewTypeByRegion;
    return {
        region,
        isCN,
        isEU,
        isUS,
        helpCenterLinkAboutAiTagging,
        helpCenterLinkAboutCustomField,
        helpCenterLinkAboutEmptyData,
        helpCenterLinkAboutSpaceTransfer,
        helpCenterLinkAboutCompanySpace,
        helpCenterLinkAboutSpaceShare,
        isImageTextShowAllFamily,
        isShowJpTranslation,
        enableStandardCompanyProfile,
        requestDemoLinkTemplate,
        defaultViewTypeByRegion,
        synapseHiddenKey,
    };
});
